import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 0H18a1.5 1.5 0 0 1 1.5 1.5v12A1.5 1.5 0 0 1 18 15H5.54l-.093.038-2.982 2.503a1.5 1.5 0 0 1-.965.356 1.55 1.55 0 0 1-.638-.15A1.47 1.47 0 0 1 0 16.387V1.5A1.5 1.5 0 0 1 1.5 0m3.91 13.5H18v-12H1.5v14.887L4.576 13.8a1 1 0 0 1 .225-.131l.347-.122a.8.8 0 0 1 .261-.047M6 6a.75.75 0 0 1 .75-.75h6a.75.75 0 1 1 0 1.5h-6A.75.75 0 0 1 6 6m.75 2.25a.75.75 0 0 0 0 1.5h6a.75.75 0 1 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }